import cn from 'classnames'
import styles from './yearBtn.module.scss'

const YearBtn = ({ isActive, children, onClick, className }) => (
  <button
    className={cn(styles.generationYearSelect, { [styles.generationYearSelectActive]: isActive }, className)}
    onClick={onClick}
  >
    {children}
  </button>
)

export default YearBtn
